module.exports = __webpack_public_path__ + "img/potencia_r_a_blue.f0f869a3.svg";